import { FREE_SHIPPING_THRESHOLD } from '../data/store';
import type { ShippingOption } from '../types/cart';

export function getShippingCost(option: ShippingOption, subtotal: number): number {
  if (option.price === 0) return 0;
  if (option.freeAboveThreshold && subtotal >= FREE_SHIPPING_THRESHOLD) return 0;
  return option.price;
}

export function remainingForFreeShipping(subtotal: number): number {
  return Math.max(0, FREE_SHIPPING_THRESHOLD - subtotal);
}
